import script from "./DataViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DataViewer.vue?vue&type=script&setup=true&lang=js"

import "./DataViewer.vue?vue&type=style&index=0&id=0c565d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c565d8c"]])

export default __exports__